import { Skeleton } from "@/components/skeleton";

export function CollaboratorsSkeleton() {
  return (
    <div className="flex flex-col gap-1.5">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-10 w-full rounded-lg" />
      <div className="flex flex-col gap-1">
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-11/12" />
        <Skeleton className="h-3 w-3/4" />
      </div>
    </div>
  );
}

export function CollaboratorsChipsSkeleton() {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton className="h-6 w-24 rounded-full" key={index} />
      ))}
    </div>
  );
}
